import { Injectable } from '@angular/core';

import { EnumTranslator, L10n, Wrapper } from '@skylab-angular-shared/core';
import { DateFormatPipe } from '@skylab-angular-shared/pipes';
import { EmailStatusDescriptorServiceBase } from '@skylab-shared/business';

export { EmailStatusDescriptorServiceBase };

@Injectable({ providedIn: 'root' })
@Wrapper(EmailStatusDescriptorServiceBase)
export class EmailStatusDescriptorService {
    public constructor(
        enumTranslator: EnumTranslator,
        l10n: L10n,
        datePipe: DateFormatPipe
    ) { }
}
